
const routeStates = {
  base: { id: 0 },
  contactBilling: { id: 1 },
  membership: { id: 1 },
  shippingOptions: { id: 4 },
  storePickup: { id: 5 },
  orderSummary: { id: 6 },
  orderConfirmation: { id: 7 },
}

export default routeStates
